import { JSX } from 'react'

import { IconProps } from '../../icon'

const Help: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M24 8C15.1713 8 8 15.1713 8 24C8 32.8287 15.1713 40 24 40C32.8287 40 40 32.8287 40 24C40 15.1713 32.8287 8 24 8ZM24 37.5385C16.5333 37.5385 10.4615 31.4667 10.4615 24C10.4615 16.5333 16.5333 10.4615 24 10.4615C31.4667 10.4615 37.5385 16.5333 37.5385 24C37.5385 31.4667 31.4667 37.5385 24 37.5385Z'
      fill='black'
    />
    <path
      d='M24 14.5641C21.5056 14.5641 19.4872 16.5826 19.4872 19.0769C19.4872 19.7497 20.0451 20.3077 20.718 20.3077C21.3908 20.3077 21.9487 19.7497 21.9487 19.0769C21.9487 17.9446 22.8677 17.0256 24 17.0256C25.1323 17.0256 26.0513 17.9446 26.0513 19.0769C26.0513 19.7333 25.7395 20.3405 25.2144 20.7344C23.6554 21.8667 22.7692 23.5077 22.7692 25.2144V25.641C22.7692 26.3138 23.3272 26.8718 24 26.8718C24.6728 26.8718 25.2308 26.3138 25.2308 25.641V25.2144C25.2308 23.9672 26.1333 23.1138 26.6749 22.72C27.8236 21.8667 28.5128 20.5046 28.5128 19.0769C28.5128 16.5826 26.4944 14.5641 24 14.5641Z'
      fill='black'
    />
    <path
      d='M24 29.3333C23.3272 29.3333 22.7692 29.8913 22.7692 30.5641V31.9426C22.7692 32.6154 23.3272 33.1733 24 33.1733C24.6728 33.1733 25.2308 32.6154 25.2308 31.9426V30.5641C25.2308 29.8913 24.6728 29.3333 24 29.3333Z'
      fill='black'
    />
  </svg>
)

export default Help
